import Module from '../../Module';

class Province extends Module {
  get baseURL() {
    return '/api/v1/cities'
  }

  parseCities(cities) {
    return cities.map(city => {
      return this.parseCity(city)
    })
  }

  parseCity(city) {
    return {
      createdAt: city.createdAt,
      deletedAt: city.deletedAt,
      id: city.id,
      name: city.name,
      prefix: city.prefix,
      province: city.province,
      provinceId: city.provinceId,
      updatedAt: city.updatedAt,
    }
  }
}

export default new Province()